import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddProperty extends Component {
    state = {
        roles: [],
        type: 'add',
        isView: false,
        Id: null,
        TenantZoneId: '',
        propertyGroupId: '',
        PropertyGroup: '',
        PropertyBlock: '',
        RoomNumber: '',
        PropertyId: '',
        PropertyName: '',
        Address: '',
        City: '',
        State: '',
        Country: '',
        ZipCode: '',
        ConstructionDetail: '',
        MeasurementsType: '',
        GrossArea: '',
        NetArea: '',
        Height: '',
        LandArea: '',
        Active: false,
        NumberOfBedSpace: '',
        BedOccupied: '',
        Status: '',
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     // this.props.getMasterKeywordList("Branch");

    //     this.props.getMasterKeywordList("tenantzone");

    //     const type = this.props.match.params.type;
    //     const id = this.props.match.params.id;

    //     // // axios.get('/master/api/DropDownValues/FRole')
    //     // //     .then(response => {
    //     // //         if (response.status === 200) {
    //     // //             let data = []
    //     // //             if (response.data && response.data.length > 0) {
    //     // //                 data = response.data.map(list => {
    //     // //                     let value = list.id;
    //     // //                     let id = list.id;
    //     // //                     let text = list.text
    //     // //                     return { label: text, value: value.toString(), id: id };
    //     // //                 })
    //     // //             }
    //     //             this.setState({ functionalRoleOptions: data })
    //     //         }
    //     // }
    //     // )
    //     // .catch(err => {
    //     //     this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
    //     // })

    //     if (type !== "add" && id) {
    //         this.props.getMasterTableList(
    //             `res/GetProperybyid?propertyId=${id}`, this.state.CompanyId
    //         );
    //     }
    // }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }
    // componentWillUnmount() {
    //     if (this.props.tableLists.propertyGroupList !== undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    // fetchSingleProcess = () => {

    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists.usersList !== undefined) {
    //         storageItems = this.props.tableLists.users;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             let roles = '';
    //             let functionalRoles = '';
    //             let approvalroles = '';
    //             if (filterData.roleAssigned != null) {
    //                 roles = filterData.roleAssigned.split(",")
    //             }
    //             if (filterData.functionalRole != null) {
    //                 functionalRoles = filterData.functionalRole.split(",")
    //             }
    //             if (filterData.approvalrole != null) {
    //                 approvalroles = filterData.approvalrole.split(",")
    //             }
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 UserId: filterData.userId,
    //                 EmployeeId: filterData.employeeId,
    //                 RoleId: roles,
    //                 approvalRoleId: approvalroles,
    //                 UserId1: filterData.userid1,
    //                 FirstName: filterData.firstName,
    //                 functionalRoleId: functionalRoles,
    //                 MiddleName: filterData.middleName,
    //                 LastName: filterData.lastName,
    //                 EmailId: filterData.emailId,
    //                 Password: filterData.password,
    //                 MobileNumber: filterData.mobileNumber,
    //                 Activedirectory: filterData.activedirectory,
    //                 Adloginid: filterData.adloginid,
    //                 Disablelogin: filterData.disablelogin,
    //                 IsActive: filterData.isActive,
    //                 CreatedBy: filterData.createdby,
    //                 CreatedDate: filterData.createddate,
    //             }
    //             this.setState(data);
    //         }
    //     }

    // }

    // componentDidUpdate(prevProps) {

    // if (
    //     this.props.tableLists &&
    //     this.props.tableLists !== prevProps.tableLists
    // ) 
    // componentDidUpdate(prevProps) {
    //     if (prevProps.tableLists !== this.props.tableLists) {
    //         console.log("API Response:", this.props.tableLists);
    //     }
    //     {

    //         const property = this.props.tableLists;
    //         // const property = this.props.tableLists.usersList;

    //         // this.setState({

    //         //     TenantZoneId: property.tenantzoneId,
    //         //     PropertyGroup: property.propertyGroup,
    //         //     PropertyBlock: property.propertyblock,
    //         //     RoomNumber: property.roomno,
    //         //     PropertyId: property.propertyId,
    //         //     PropertyName: property.propertyName,
    //         //     Address: property.address,
    //         //     City: property.city,
    //         //     State: property.state,
    //         //     Country: property.country,
    //         //     ZipCode: property.zipCode,
    //         //     ConstructionDetail: property.constructionalDetail,
    //         //     MeasurementsType: property.measurementsType,
    //         //     GrossArea: property.grossArea,
    //         //     NetArea: property.netArea,
    //         //     Height: property.height,
    //         //     LandArea: property.landArea,
    //         //     Active: property.active,
    //         //     NumberOfBedSpace: property.numberofbedspace,
    //         //     BedOccupied: property.bedoccupied,
    //         //     Status: property.status,

    //         // });

    //         this.setState({

    //         });
    //     }
    // }

    componentDidMount() {
        const type = this.props.match.params.type;   // add / edit / view
        const id = this.props.match.params.id;
        console.log('Component mounted with type:', type, 'id:', id);

        this.setState({
            type: type,
            isView: type === "view"
        });

        this.props.getMasterKeywordList("Country");
        this.props.getMasterKeywordList("tenantzone");
        this.props.getMasterKeywordList("TBS_PROPERTY_STATUS");
        this.props.getMasterKeywordList("TBS_PROPERTY_TYPE");
        this.props.getMasterKeywordList("PropertyGroup");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetProperybyid?PropertyId=${id}`,
                this.state.CompanyId
            );
        }
    }

    componentDidUpdate(prevProps) {

        if (
            this.props.tableLists &&
            this.props.tableLists !== prevProps.tableLists
        ) {
            console.log(this.props.tableLists);
            const property = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            this.setState({
                TenantZoneId: property.tenantzoneId || '',
                PropertyGroup: property.propertyGroupId || '',
                // PropertyGroup: property.propertyGroup || '',
                PropertyBlock: property.propertyblock || '',
                RoomNumber: property.roomno || '',
                PropertyId: property.propertyId || '',
                PropertyName: property.propertyName || '',
                Address: property.address || '',
                City: property.city || '',
                State: property.state || '',
                Country: property.country || '',
                ZipCode: property.zipCode || '',
                ConstructionDetail: property.constructionalDetail || '',
                MeasurementsType: property.measurementsType || '',
                GrossArea: property.grossArea || '',
                NetArea: property.netArea || '',
                Height: property.height || '',
                LandArea: property.landArea || '',
                Active: property.active || false,
                NumberOfBedSpace: property.numberofbedspace || '',
                BedOccupied: property.bedoccupied || '',
                Status: property.status || ''
            });
        }
    }

    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }
    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    add = () => {

        if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.RoleId === null || this.state.RoleId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
            return;
        }

        else if (this.state.UserId1 === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
            return;
        } else if (this.state.FirstName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
            return;
        } else if (this.state.LastName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
            return;
        } else if (this.state.EmailId === "" || this.state.EmailId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
            return;
        } else if (this.state.Password === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
            return;
        } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
            return;
        } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
            return;
        }
        var data = {
            tenantzoneId: this.state.TenantZoneId,
            // propertyGroup: this.state.PropertyGroup,
            propertyGroupId: this.state.PropertyGroup,
            propertyblock: this.state.PropertyBlock,
            roomno: this.state.RoomNumber,
            // propertyId: this.state.PropertyId,
            propertyName: this.state.PropertyName,
            address: this.state.Address,
            companyid :this.state.CompanyId,
            city: this.state.City,
            state: this.state.State,
            country: this.state.Country,
            zipCode: this.state.ZipCode,
            constructionalDetail: this.state.ConstructionDetail,
            measurementsType: this.state.MeasurementsType,
            grossArea: this.state.GrossArea,
            netArea: this.state.NetArea,
            height: this.state.Height,
            landArea: this.state.LandArea,
            active: this.state.Active,
            numberofbedspace: this.state.NumberOfBedSpace,
            bedoccupied: this.state.BedOccupied,
            status: this.state.Status,
        }


        if (this.state.type === "edit") {
            // data.propertygroupId = this.state.PropertyGroupId;
            // or
            data.propertyId = this.state.PropertyId;   // based on your API
        }

        this.props.processDynamicData('property', this.state.type, data, 'res/GetProperybyid?' + Companyid);
    }

    resetData = () => {
        var data = {
            // roles: [],
            type: 'add',
            Id: null,
            TenantZoneId: '',
            propertyGroupId: '',
            PropertyGroup: '',
            PropertyBlock: '',
            RoomNumber: '',
            PropertyId: '',
            PropertyName: '',
            Address: '',
            City: '',
            State: '',
            Country: '',
            ZipCode: '',
            ConstructionDetail: '',
            MeasurementsType: '',
            GrossArea: '',
            NetArea: '',
            Height: '',
            LandArea: '',
            Active: false,
            NumberOfBedSpace: '',
            BedOccupied: '',
            Status: '',
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/Property/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/Property/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }

        const { id, name, label, value, placeholder, fieldStatus, onInputChange, disabled, style } = this.props;


        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Property</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Tenant Zone  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Tenant Zone" options={this.props.tenantzone} value={this.state.TenantZoneId} name="TenantZoneId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Property Group  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Property Group" options={this.props.PropertyGroup} value={String(this.state.propertyGroupId)} name="propertyGroupId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Property Block  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Property Block" options={this.props.TBS_PROPERTY_TYPE} value={this.state.PropertyBlock} name="PropertyBlock" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Room Number <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="RoomNumber" placeholder="Room Number" value={this.state.RoomNumber} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Property ID <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="PropertyId" placeholder="Property ID" value={this.state.PropertyId} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div> */}

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Property Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="PropertyName" placeholder="Property Name" value={this.state.PropertyName} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Address <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Address" placeholder="Address" value={this.state.Address} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">City <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="City" placeholder="City" value={this.state.City} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">State <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="State" placeholder="State" value={this.state.State} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Country <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Country" options={this.props.Country} value={this.state.Country} name="Country" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple"> Zip<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="ZipCode" placeholder="Zip" value={this.state.ZipCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <label htmlFor="details">Construction Details</label>
                                    </div>
                                    <div className="p-col-12">
                                        <textarea
                                            rows="4"
                                            name="ConstructionDetail"
                                            id="details"
                                            placeholder="Construction Details"
                                            className="p-col-12 p-inputtext"
                                            autoComplete="off"
                                            style={{ resize: 'vertical' }}
                                            value={this.state.ConstructionDetail}
                                            onChange={this.change}
                                            disabled={this.state.type === 'view'}
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">Measurements<span className="requiredColor">*</span></label>
                                    <div className="p-grid" style={{ marginTop: '0.5em' }}>
                                        <div className="p-col-12 p-md-6">
                                            <RadioButton
                                                value={1}
                                                checked={this.state.MeasurementsType === 1}
                                                onChange={(e) => this.setState({
                                                    MeasurementsType: e.value,
                                                    touch: true
                                                })}
                                            />
                                            {/* <RadioButton value="male" name="Gender" onChange={event => this.setState({ Gender: 1 })} checked={this.state.Gender === 1 || this.state.Gender === "1"} /> */}

                                            <label htmlFor="rb1" className="p-radiobutton-label">Feet/Sq.Feet</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                            <RadioButton
                                                value={2}
                                                checked={this.state.MeasurementsType === 2}
                                                onChange={(e) => this.setState({
                                                    MeasurementsType: e.value,
                                                    touch: true
                                                })}
                                            />
                                            {/* <RadioButton value="female" name="Gender" onChange={event => this.setState({ Gender: 2 })} checked={this.state.Gender === 2 || this.state.Gender === "2"} /> */}
                                            <label htmlFor="rb1" className="p-radiobutton-label">Meter/Sq.Meter</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple"> Gross Floor Area<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="GrossArea" placeholder="Gross Floor Area" value={this.state.GrossArea} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple"> Net Lat - Area<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="NetArea" placeholder="Net Lat- Area" value={this.state.NetArea} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Height<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Height" placeholder="Height" value={this.state.Height} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Land Area<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="LandArea" placeholder="Land Area" value={this.state.LandArea} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12" style={style ? style : { marginTop: '38px' }}>
                                    {/* <Checkbox
                                        name={name}
                                        inputId="applyLateFee"
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e) => this.setState({ applyLateFee: e.checked, touch: true })}
                                        checked={this.state.applyLateFee} />
                                    disabled={this.state.type === 'view'} */}
                                    <Checkbox
                                        inputId="Active"
                                        checked={this.state.Active}
                                        onChange={(e) =>
                                            this.setState({
                                                Active: e.checked,
                                                touch: true
                                            })
                                        }
                                        disabled={this.state.type === 'view'}
                                    />
                                    <label htmlFor="Active" className="p-checkbox-label">Active</label>
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Number of Bed Space<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="NumberOfBedSpace" placeholder="Number of Bed Space" value={this.state.NumberOfBedSpace} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Bed Occupied<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="BedOccupied" placeholder="Bed Occupied" value={this.state.BedOccupied} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Status" options={this.props.TBS_PROPERTY_STATUS} value={String(this.state.Status)} name="Status" onChange={this.change} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>


                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div> */}
                            </div>
                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/Property/"
                                />

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        tenantzone: (state.keyword.tenantzone !== undefined) ? state.keyword.tenantzone : [],
        Country: (state.keyword.Country !== undefined) ? state.keyword.Country : [],
        TBS_PROPERTY_STATUS: (state.keyword.TBS_PROPERTY_STATUS !== undefined) ? state.keyword.TBS_PROPERTY_STATUS : [],
        TBS_PROPERTY_TYPE: (state.keyword.TBS_PROPERTY_TYPE !== undefined) ? state.keyword.TBS_PROPERTY_TYPE : [],
        PropertyGroup: (state.keyword.PropertyGroup !== undefined) ? state.keyword.PropertyGroup : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddProperty);